<nb-card>
  <nb-card-header>
    <span>
      {{ "Price sheets" | translate }}
    </span>
    <span class="breadcrumb">
      <span class="cat-name">{{ createBreadCrumb() }} ></span> <span class="type-name">{{ assetType.name }}</span>
    </span>
  </nb-card-header>
  <nb-card-body>
    <app-price-sheets-list
      [priceSheets]="priceSheets"
      [assetType]="assetType"
      [assetQuantity]="assetQuantity"
      [currentAssetId]="assetId"
      [isPPA]="isPPA"
      [showIsDefault]="priceSheets?.length > 1"
      (priceSheetsChanges)="hasPriceSheetsChanged($event)"
      (customerPsDeleted)="customerPsRemoved($event)"
      (closeAfterChanges)="closeWithParams()"
      (priceTierChanged)="onPriceTierChanged($event)"
    ></app-price-sheets-list>
  </nb-card-body>
  <nb-card-footer class="text-right">
    <div class="container-fluid">
      <div class="row m-0 pb-2">
        <div class="col-10">
          @if (canEdit) {
            + <span class="add-ps" (click)="addPriceSheet()">{{ "Add a pricesheet" | translate }}</span>
          }
        </div>
        <div class="col-2">
          <button nbButton type="submit" (click)="close()" class="w-100">{{ 'OK' | translate }}</button>
        </div>
      </div>
    </div>
  </nb-card-footer>
</nb-card>
